import API from './config'

export const FundsManagersAdministratorsAPI = {

    async getAllManagers() {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fundsManagers/getAll', config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async getAllAdministrators() {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fundsAdministrators/getAll', config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    //Dispara manualmente a rotina do job (processa sempre o mês anterior)
    async processFundsManagersAndAdministrators() {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fundsManagersAdministrators/process', {}, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async updateManagerInstituition(id, instituitionId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/fundsManagers/updateInstituition',
                { id: id, instituition_id: instituitionId }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    //Aplica a mesma instituição a vários gestores (instituitionId nulo desvincula)
    async updateManagersInstituitionBatch(ids, instituitionId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/fundsManagers/updateInstituitionBatch',
                { ids: ids, instituition_id: instituitionId }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    //Aplica a mesma instituição a vários administradores (instituitionId nulo desvincula)
    async updateAdministratorsInstituitionBatch(ids, instituitionId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/fundsAdministrators/updateInstituitionBatch',
                { ids: ids, instituition_id: instituitionId }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async updateAdministratorInstituition(id, instituitionId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/fundsAdministrators/updateInstituition',
                { id: id, instituition_id: instituitionId }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    //Nomes alternativos: outros nomes que representam o mesmo gestor/administrador nas
    //bases com as quais esse cadastro é cruzado
    async getManagerNames(managerId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fundsManagers/names/' + managerId, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async createManagerName(managerId, name) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fundsManagers/names',
                { entity_id: managerId, name: name }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async deleteManagerName(nameId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/fundsManagers/names/' + nameId, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async getAdministratorNames(administratorId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fundsAdministrators/names/' + administratorId, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async createAdministratorName(administratorId, name) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fundsAdministrators/names',
                { entity_id: administratorId, name: name }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

    async deleteAdministratorName(nameId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/fundsAdministrators/names/' + nameId, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error
            };
        }
    },

}
